import styled, { css } from 'styled-components'
import IconButton from '../Buttons/IconButton'
import Blink from '../Blink'
import { mobileAndTabletCSS } from '@measures/responsive'

const TooltipTitle = styled.div`
  ${({
    theme: {
      typography: {
        subheads: {
          small1: { bundledCSS: small1SubheadingCSS },
        },
      },
      colors: { textDefault },
    },
  }) => css`
    ${small1SubheadingCSS};
    color: ${textDefault};
  `}
`
const TooltipText = styled.div`
  ${({
    theme: {
      typography: {
        bodycopy: {
          xsmall: { bundledCSS: xsmallBodycopyCSS },
        },
      },
      colors: { textDefault },
    },
  }) => css`
    ${xsmallBodycopyCSS};
    color: ${textDefault};
  `}
`
const TooltipCloseButton = styled(IconButton)`
  ${({
    theme: {
      spacing: { spacing24 },
    },
  }) => css`
    grid-area: 1 / 2 / 2 / 3;
    justify-self: end;
    width: ${spacing24};
    height: ${spacing24};
  `}
`

const TooltipContainer = styled.div`
  ${({
    theme: {
      colors: { fillDefault },
      spacing: { spacing4, spacing12, spacing16 },
    },
  }) => css`
    display: grid;
    gap: ${spacing12};
    grid-template-columns: 1fr auto;
    max-width: 326px;
    width: 326px;
    position: relative;
    border-radius: ${spacing4};
    background-color: ${fillDefault};
    padding: ${spacing16};

    ${mobileAndTabletCSS(css`
      max-width: 300px;
      width: 300px;
    `)}
  `}
`

const TextWrapper = styled.div`
  grid-area: 1 / 1 / 2 / 2;
`

const TooltipLink = styled(Blink)`
  ${({
    theme: {
      colors: { textDefault },
      typography: {
        subheads: {
          small1: { bundledCSS: small1SubheadingCSS },
        },
      },
    },
  }) => css`
    text-decoration: none;
    ${small1SubheadingCSS};
    color: ${textDefault};
    grid-area: 2 / 1/ 3 / 3;
    justify-self: end;
  `}
`

export {
  TooltipLink,
  TextWrapper,
  TooltipContainer,
  TooltipCloseButton,
  TooltipTitle,
  TooltipText,
}
